const env = window.__ENV__ || {};

export const CONFIG = {
  REACT_APP_API_BASE_URL: env.REACT_APP_API_BASE_URL
  
};